import Blurhash from "@components/blurhash";
import { useViewContext } from "@editor-providers";
import { useState } from "react";
import { getBlurhashFromUrl } from "@/shared";

const SHARED_CLASS =
  "tw-relative tw-z-0 tw-h-full tw-w-full tw-object-cover tw-block";

export const BackgroundNode = ({
  type,
  url,
  isVisible,
}: {
  type: "image" | "video";
  url: string;
  isVisible: boolean;
}) => {
  const { view } = useViewContext();
  const pdf = view === "pdf";

  if (type === "image") return <Image url={url} isVisible={isVisible} />;
  if (type === "video")
    return <Video url={url} pdf={pdf} isVisible={isVisible} />;
  return null;
};

const Image = ({ url, isVisible }: { url: string; isVisible: boolean }) => {
  const hash = getBlurhashFromUrl(url);
  const [loaded, setLoaded] = useState(false);
  return (
    <>
      {hash && !loaded && <Blurhash blurhash={hash} />}
      {isVisible && (
        <img
          src={url}
          alt=""
          role="presentation"
          className={SHARED_CLASS}
          onLoad={() => setLoaded(true)}
        />
      )}
    </>
  );
};

const Video = ({
  url,
  pdf,
  isVisible,
}: {
  url: string;
  pdf: boolean;
  isVisible: boolean;
}) => {
  if (!isVisible) return null;
  return (
    <video
      className={SHARED_CLASS}
      autoPlay={!pdf}
      loop={!pdf}
      muted
      key={url}
      playsInline={!pdf}
      preload={pdf ? "auto" : undefined}
    >
      <Source url={url} />
    </video>
  );
};

const Source = ({ url }: { url: string }) => {
  if (url.endsWith(".webm")) {
    const mp4Url = url.replace(/\.webm$/, ".mp4");
    return (
      <>
        <source src={`${url}#t=0.1`} type="video/webm" />
        <source src={`${mp4Url}#t=0.1`} type="video/mp4" />
      </>
    );
  }
  return <source src={`${url}#t=0.1`} type="video/mp4" />;
};
